import { getFetch } from '../fetch';

import { apiConfig } from '../config';

export function getThemeProblems({ themeId, showAll, filters }: any) {
    const { apiGetThemeProblems } = apiConfig.getStaticUrls();

    return getFetch(apiGetThemeProblems, {
        filters: JSON.stringify(filters),
        themeId,
        showAll,
    });
}
